<script>
export default {
    name: "ColorCircle",
    props: {
        hex: {
            type: String,
            default: '#000000'
        }
    }
}
</script>

<template>
  <span class="flex items-center justify-center w-4 h-4 rounded-full border border-gray-400"
        :style="{'background-color': hex}">
      <span class="w-1.5 h-1.5 rounded-full bg-white border border-gray-400"></span>
  </span>
</template>

<style scoped lang="scss">

</style>
